<template>
  <div>
    <OrdersNav
        @search_by_title="searchByTitle"
        @filter="applyFilter"
        @clear="clearFilters"
        @create_order="openOrderDialog"
        @manage="openManageView"
        @ListDevices_show="ListDevices_show = true"
        @get_report="openReportDialog"
    />
    <v-alert v-if="is_filtered" color="white" class="text-center mx-5 mt-5">
      <h2 class="text-success">
        فیلتر شده با
        {{ getFilterName(filter_by.key) }}
        برابر
        <strong>"<i>{{ filter_by.value }}</i>"</strong>
      </h2>
    </v-alert>
    <OrdersList
        @refresh_orders="getOrders"
        :orders="orders"
        :is_searched="is_searched || is_filtered"
        @change_tab="changeTab"
        @change_page="changePage"
        :receiving_orders="receiving_orders"
        :page="page"
    />
    <CreateOrder
        v-if="add_order_dialog"
        :manage_data="manage_data"
        :add_order_dialog="add_order_dialog"
        :loading_data="loading_create_data"
        @force_update_data="updateCreateData"
        @close="add_order_dialog = false"
        @refresh_orders="getOrders"
    />
    <GetReport
        v-if="get_report_dialog"
        @close="get_report_dialog = false"
        :show_report="get_report_dialog"
        :manage_data="manage_data"
        :users_l2="users.l2"
        :users_l1="users.l1"
    />
  </div>
</template>

<script>
import axios from "axios";
import OrdersList from "@/components/Orders/list.vue";
import CreateOrder from "@/components/Orders/create.vue";
import OrdersNav from "@/components/Orders/nav.vue";
import GetReport from "@/components/Orders/report.vue";

export default {
  name: "HomeOrders",
  components: { OrdersNav, OrdersList, CreateOrder, GetReport },
  data() {
    return {
      key: localStorage.getItem("key"),
      receiving_orders: true,
      is_searched: false,
      is_filtered: false,
      add_order_dialog: false,
      tab: null,
      orders: [],
      page: 1,
      steps: ['Created','Processing','Finish'],
      filter_by: {},
      manage: {
        show: false,
        manage: "location",
        title: "",
        items: [
          { title: "مکان ها", model: "locations" },
          { title: "تگ ها", model: "tags" },
          { title: "دسته‌بندی", model: "categories" },
        ],
      },
      manage_data: [],
      users: { l1: [], l2: [] },
      devices: [],
      loading_create_data: false,
      ListDevices_show: false,
      get_report_dialog: false,
    };
  },
  created() {
    this.getOrders();
  },
  methods: {
    getFilterName(key) {
      const filterMap = {
        user_1: "کاربر سطح یک",
        user_2: "کاربر سطح دو",
        location: "مکان",
        tag: "تگ",
      };
      return filterMap[key] || "";
    },
    applyFilter(filter_by) {
      this.page = 1;
      this.filter_by = filter_by;
      this.getFilteredOrders();
    },
    getFilteredOrders() {
      this.clearOrders();
      this.receiving_orders = true;
      axios
          .get(`${this.BACKEND_LINK}/api/shop-order/`, {
            params: {
              location: this.filter_by.value,
              page: this.page,
            },
            headers: { Authorization: `Token ${this.key}` },
          })
          .then((response) => {
            this.orders = response.data;
            if (this.page === 1) {
              this.$snotify.success(`${response.data.count} عدد کار پیدا شد`, "فیلتر");
            }
            this.is_filtered = true;
          })
          .catch((errors) => {
            this.$snotify.error(`مشکلی پیش آمد کد : ${errors.response.status}`, "فیلتر");
          })
          .finally(() => {
            this.receiving_orders = false;
          });
    },
    openManageView(manage) {
      this.manage.manage = manage.model;
      this.manage.title = manage.title;
      this.manage.show = true;
    },
    updateCreateData() {
      this.loading_create_data = true;
      this.manage_data = [];
      this.users.l2 = [];
      this.devices = [];
      this.loadOrderManagementData();
    },
    loadOrderManagementData() {
      this.getManageData();
    },

    getManageData() {
      axios
          .get(`${this.BACKEND_LINK}/api/tasks/manage/?model=*`, {
            headers: { Authorization: `Token ${this.key}` },
          })
          .then((response) => {
            this.manage_data = response.data;
          });
    },
    changePage(page) {
      this.page = page;
      this.is_filtered ? this.getFilteredOrders() : this.getOrders();
    },
    changeTab(tab) {
      this.tab = tab;
      try{
        this.getOrders();
      }catch(error){
        this.$snotify.error(`مشکلی پیش آمد کد : ${errors}`);
      }
    },
    searchByTitle(search_field) {
      if (search_field?.length >= 3) {
        this.clearOrders();
        this.receiving_orders = true;
        axios
            .get(`${this.BACKEND_LINK}/api/shop-order/?search=${search_field}`, {
              headers: { Authorization: `Token ${this.key}` },
            })
            .then((response) => {
              this.orders.results = response.data.results;
              this.$snotify.success(`${response.data.count} عدد کار پیدا شد`, "فیلتر");
              this.is_searched = true;
            })
            .catch((errors) => {
              this.$snotify.error(`مشکلی پیش آمد کد : ${errors.response.status}`, "فیلتر");
            })
            .finally(() => {
              this.receiving_orders = false;
            });
      }
    },
    getOrders() {
      this.clearOrders();
      this.receiving_orders = true;
      axios
          .get(`${this.BACKEND_LINK}/api/shop-order/?page=${this.page}${this.tab? '&step=' + this.steps[this.tab?.[4]-1]:''}`, {
            headers: { Authorization: `Token ${this.key}` },
          })
          .then((response) => {
            this.orders = response.data;
          })
          .finally(() => {
            this.receiving_orders = false;
          });
    },
    clearOrders() {
      this.orders = [];
    },
    clearFilters() {
      this.getOrders();
      this.is_searched = false;
      this.is_filtered = false;
    },
    openOrderDialog() {
      this.add_order_dialog = true;
      this.loadOrderManagementData();
    },
    openReportDialog() {
      this.get_report_dialog = true;
      this.loadOrderManagementData();
    },
  },
};
</script>
